<template>
	<div>
		<div class="main">	
            <router-link to="/" class="onboarding-close">
                <span class="icon-close-large"></span>
            </router-link>
			<div class="container">	
				<div class="row center middle onboarding-wrap">
					<div class="col-lg-4 col-sm-6 col-md-9 col-xs-11">
						<div class="onboarding-logo">
							<img src="/static/images/logo-onboarding.svg" alt="" />
						</div>
						<form class="form" @submit.prevent>
							<div class="row">
								<div class="col-lg-12">
									<input-widget :placeholder="$t('label.email')"
										validate="required|email"
										v-model.trim="email">
									</input-widget>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-12">
                                    <br />
									<button @click="validateForm" :class="{ 'button-full': true, 'loading': loading }" type="submit">{{ $t("button.submit") }}</button>
								</div>
							</div>
						</form>					
						<p class="onboarding-link">
							<router-link to="login">{{ $t("message.login") }}</router-link> <span class="separator">|</span> <router-link to="register">{{ $t("message.register") }}</router-link>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import InputWidget from '@/components/widgets/InputWidget'

export default {
  name: 'ForgotPasswordPage',
  components: {InputWidget},
  data () {
    return {
      email: '',
      loading: false
    }
  },
  methods: {
    validateForm () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.sendRequest()
        }
      })
    },
    sendRequest () {
      this.loading = true
      this.$api.post('/v1/auth/password/email', { email: this.email })
      .then(() => {
        this.loading = false
        this.$events.fire('message-open', {
          type: 'success',
          message: this.$t('message.checkYourEmail')
        })
      })
      .catch(() => {
        this.loading = false
        this.$events.fire('message-open', {
          type: 'error',
          message: this.$t('message.mailNotFound')
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Homepage/ForgotPassword.vue